import { motion, AnimatePresence } from "framer-motion";

const textWords = ["VetAssist", "Clinic", "Software"];

const container = {
  hidden: { opacity: 1 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.1 },
  },
};

const word = {
  hidden: { y: "130%", skewY: 7, opacity: 0 },
  show: {
    y: "0%",
    skewY: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: [0.19, 1, 0.22, 1] },
  },
};

const topBadge = {
  hidden: { opacity: 0, scale: 0.9 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.4, ease: "easeOut", delay: 0 } },
};

const accentLine = {
  hidden: { width: 0 },
  show: { width: "60px", transition: { duration: 0.5, ease: "easeInOut", delay: 0.3 } },
};

const IntroTextOverlay = ({ visible }) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          exit={{ opacity: 0, filter: "blur(10px)", transition: { duration: 0.2 } }}
          className="pointer-events-none fixed inset-0 z-[100] flex flex-col items-center justify-center gap-8 bg-white"
          style={{ willChange: "opacity, filter" }}>
          <motion.div variants={topBadge} className="flex items-center gap-3 px-4 text-center">
            <motion.span variants={accentLine} className="hidden h-px bg-[#295CAC] sm:block" />
            <span className="text-[10px] font-semibold tracking-[0.35em] whitespace-nowrap text-slate-400 uppercase sm:text-xs">
              Clinic First
            </span>
            <motion.span variants={accentLine} className="hidden h-px bg-[#1A3A5C] sm:block" />
          </motion.div>

          <div className="w-full overflow-hidden px-4">
            <div className="mx-auto flex max-w-[90vw] flex-wrap justify-center gap-x-3 gap-y-1 text-center">
              {textWords.map((item, i) => (
                <div key={i} className="overflow-hidden">
                  <motion.span
                    variants={word}
                    className="block text-4xl font-medium tracking-tight whitespace-nowrap text-slate-800 sm:text-5xl md:text-6xl lg:text-7xl"
                    style={{ willChange: "transform, opacity" }}>
                    {item}
                  </motion.span>
                </div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col items-center gap-2"
            style={{ willChange: "opacity" }}>
            <div className="h-12 w-px bg-linear-to-b from-slate-200 to-transparent" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroTextOverlay;
